import React, { useEffect, useState } from 'react'
import { useConfig } from '../../../Providers/ConfigProvider'
import { GetRelatedProducts, GetRelatedProductsForArtsList } from '../../../Services/ProductService'
import { useAuth } from '../../../Providers/AuthProvider'

/**
 * Hook do pobierania produktów powiązanych oraz zamów również
 * @param product - Pojedyńczy produkt dla którego pobieramy dane
 * @param productsList - Lista produktów dla których chcemy pobrać dane
 */
const useGetRelatedProducts = (product, productsList) => {
    const { api } = useConfig()
    const { authState } = useAuth()
    const [relatedProducts, setRelatedProducts] = useState([])
    const [isRelatedProductsLoading, setIsRelatedProductsLoading] = useState(false)

    useEffect(() => {
        if (product) {
            setIsRelatedProductsLoading(true)
            GetRelatedProducts(api, product.index, authState.custId, authState.siteId, authState.whId)
                .then(res => {
                    setRelatedProducts(res.data)
                    setIsRelatedProductsLoading(false)
                })
                .catch(e => console.log(e))
        }
        if (productsList && productsList.length > 0) {
            let productsIds = productsList.map(x => x.artNo)
            setIsRelatedProductsLoading(true)
            GetRelatedProductsForArtsList(api, productsIds, authState.custId, authState.siteId, authState.whId)
                .then(res => {
                    setRelatedProducts(res.data)
                    setIsRelatedProductsLoading(false)
                }).catch(e => console.log(e))
        }
    }, [product, productsList])

    return {
        relatedProducts,
        isRelatedProductsLoading
    }
}

export default useGetRelatedProducts